import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { changeRule, changeRuleDirty } from '../../../redux/actions/RuleActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../domain/access/BaseAccess';
import AccessContainer from '../../access/AccessContainer';
import RoleHelper from '../../../RoleHelper';

class RuleAccessComponent extends Component<Props> {
  render() {
    const {
      rule: { rule },
    } = this.props;
    const access: AccessBase = { permission: rule.permission, collaborators: rule.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeRuleAccess} disabled={!RoleHelper.canManage('Rule')} />;
  }

  private changeRuleAccess = (access: AccessBase) => {
    const {
      rule: { rule },
      changeRule,
      changeRuleDirty,
    } = this.props;
    rule.permission = access.permission;
    rule.collaborators = access.collaborators;
    changeRule(rule);
    changeRuleDirty(true);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  rule: state.rule,
});
const mapDispatchToProps = { changeRule, changeRuleDirty };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(RuleAccessComponent);
